// type safe replacement for (some use cases of) Object.assign()
export function assign<T>(a: T, b: Partial<T>): T {
  return Object.assign({}, a, b);
}
